export default {
	inProcessDev: `Сторінка знаходиться в процесі розробки! <br/> Скоро ви зможете використовувати всі її функції. <br/> <strong> Дякую за розуміння </strong>`,
}